import PropTypes from "prop-types"
import { useContext, useEffect } from "react"
import LinearProgressLoader from "~/components/LinearProgressLoader"
import { DEFAULT_OPTIONS } from "~/constants/docs"
import AppContext from "~/contexts/App"
import { useGetDocs } from "~/hooks/useGetDocs"
import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import Page from "~/pages/Page"
import Router from "~/router"

const Docs = ({ routes = [], ...rest }) => {
  const { setPageTitle, setPageSubTitle } = useContext(AppContext)

  const { data, isLoading } = useGetDocs(DEFAULT_OPTIONS)
  usePermissionsRedirect("/learning-paths", "docs")
  useEffect(() => {
    setPageTitle("Docs")
    setPageSubTitle(data?.total || 0)
  }, [data])

  return (
    <Page>
      <DocsWrapper isLoading={isLoading}>
        <Router routes={routes} {...rest} />
      </DocsWrapper>
    </Page>
  )
}
Docs.propTypes = {
  routes: PropTypes.array,
}

const DocsWrapper = ({ isLoading, children }) => {
  if (isLoading) {
    return <LinearProgressLoader />
  } else {
    return children
  }
}

DocsWrapper.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  options: PropTypes.object,
  setOptions: PropTypes.func,
}

export default Docs
